import { render, staticRenderFns } from "./AscSurfaceTitle.vue?vue&type=template&id=7bc0f573&"
import script from "./AscSurfaceTitle.vue?vue&type=script&lang=js&"
export * from "./AscSurfaceTitle.vue?vue&type=script&lang=js&"
import style0 from "./AscSurfaceTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports